import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RatePackageEventType } from './../rate-package.event.type';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { TweenMax, Quint } from 'gsap';
import { RatePackageService } from './../rate-package.service';
import { MatTableDataSource } from '@angular/material/table';
import { Record } from '../models/record';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { ExtratoPacote } from '../models/extrato-pacote.model';
import { Util } from '../../../utils/util';

@Component({
	selector: 'app-extract-package',
	templateUrl: './extract-package.component.html',
	styleUrls: ['./extract-package.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ExtractPackageComponent implements OnInit {

	public active: Boolean = false;
	public extractRecords: Record[] = [];
	public dataSource: MatTableDataSource<Record>;
	public displayedColumns: Array<string> = ['moviment', 'hired', 'used', 'value', 'excess', 'total'];
	public haventRegisters = true;
	public monthsNames: Array<string>;
	public monthText: string;
	public month: number;
	public year: number;

	constructor(private ratePackageService: RatePackageService, private route: ActivatedRoute) {}

	ngOnInit() {
		moment.locale('pt-br');
		this.monthsNames = moment.months();

		AppEventDispatcher.listen(RatePackageEventType.STEPS.EXTRACT, data => {
			if (data.show) {
				this.show();
			} else {
				this.hide();
			}
		});
	}

	show() {
		this.active = true;
		const today = new Date();
		this.month = today.getMonth() + 1;
		this.monthText = this.monthsNames[this.month - 1];
		this.year = today.getFullYear();

		this.getExtract(moment(this.year + '-' + this.month + '-' + moment(this.year + '-' + this.month, 'YYYY/MM').daysInMonth()).format('YYYY-MM-DD'));
	}

	getExtract(date: string) {
		this.preload(true);

		this.ratePackageService.getExtract(date).subscribe(data => {
			this.extractRecords = [];
			if (data.Sucesso && data.Retorno) {
				const extract = Util.keysToCamel(data.Retorno) as ExtratoPacote[];
				this.convertExtractToTable(extract);
			}
			this.preload(false);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro, tente novamente mais tarde.' });
			this.preload(false);
		});
	}

	convertExtractToTable(extract: ExtratoPacote[]) {
		this.extractRecords = extract.map((data: ExtratoPacote) => {
			const tipoCanal = data.canais.find(o => o.tpCanal === 'Internet');
			return new Record(
				data.nmServico,
				tipoCanal.qtdContratada,
				tipoCanal.qtdUtilizada,
				tipoCanal.qtdExcedente,
				tipoCanal.vlrUnitario,
				tipoCanal.vlrTotServico,
			);
		});

		this.dataSource = new MatTableDataSource(this.extractRecords);
	}

	onChangeMonthEmit(event: string) {
		this.getExtract(event);
	}

	hide = () => this.active = false;

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {
			element: '[data-component="rate-packege"] .content',
			show: active,
			delay: delay
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rate-package/extract-package/extract-package.component.ts